import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AxiosController from "../../../authentication/AxiosController";
import Loader from "../../../loader/Loader";
import CurrencyAddAndUpdate from "../../../modals/CurrencyAddAndUpdate";
import CurrencyTable from "./CurrencyTable";
import { Helmet } from "react-helmet";

const Currency = () => {
  const {  lang } = useParams();
  const [_] = useTranslation("global");
  const token = localStorage.getItem("token");
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [loading, handleLoader] = useState(false);
  const fetchCurrency = () => {
    AxiosController.get(`api/${lang}/auth/user-currencies`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        handleLoader(false);
        setData(res.data);
      })
      .catch((e) => {
        handleLoader(false);
      });
  };
  useEffect(() => {
    fetchCurrency();
  }, []);
  return (
    <Container style={{ position: "relative" }}>
      <Helmet>
        <title>{_("panel.countries")}</title>
      </Helmet>
      <Loader active={loading} />
      <CurrencyAddAndUpdate
        show={show}
        setShow={setShow}
        update={false}
        fetchCurrency={() => fetchCurrency()}
      />
      <div className="add-product-container d-flex flex-column gap-2 my-3 px-4">
    
        <div
          className="d-flex gap-5 flex-column-reverse flex-md-row"
          dir={lang === "en" ? "ltr" : "rtl"}
        >
          <Button
            className="px-4"
            variant="primary"
            onClick={() => {
              setShow(true);
            }}
            style={{ background: "#59C6C9", color: "white", border: "none" }}
          >
            {_("panel.add")}
          </Button>
        </div>
    <div className="add-header" dir={lang === "en" ? "ltr" : "rtl"}>
          <h3 className="mb-3 fs-1" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.countries")}
          </h3>
        </div>
        <CurrencyTable data={data} fetchCurrency={() => fetchCurrency()} />
      </div>
    </Container>
  );
};

export default Currency;
